import axios from 'axios';
import type { Tag } from '@/models/tag';

class TagWebservice {
    public load() {
        return axios.get<Tag[]>('/tags');
    }

    public getById(tagId: number) {
        return axios.get<Tag>('/tags/getById', {
            params: {
                id: tagId,
            },
        });
    }

    public store(tag: Tag) {
        return axios.post('/tags/store', {
            title: tag.title,
            default: tag.default,
        });
    }

    public update(tag: Tag) {
        return axios.post('/tags/update', {
            id: tag.id,
            title: tag.title,
            default: tag.default,
        });
    }

    public remove(tag: Tag) {
        return axios.post('/tags/remove', {
            id: tag.id,
        });
    }
}

export const tagWebservice = new TagWebservice();
